import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { DashboardFilterProvider } from '../../contexts/DashboardFilterContext';

const AdminLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <div className="admin-ui min-h-screen bg-slate-100 text-slate-800">
      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 z-40 bg-slate-950/45 backdrop-blur-[2px] lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div className={`fixed inset-y-0 left-0 z-50 ${isCollapsed ? 'w-16' : 'w-60'} transform transition-transform duration-300 ease-out lg:translate-x-0 ${
        sidebarOpen ? 'translate-x-0' : '-translate-x-full'
      }`}>
        <Sidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
      </div>

      {/* Main content */}
      <div className={`transition-[margin] duration-300 ease-out ${isCollapsed ? 'lg:ml-16' : 'lg:ml-60'}`}>
        <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
        <main className="p-2.5 sm:p-3 lg:p-4">
          <div className="mx-auto max-w-[1500px]">
            <DashboardFilterProvider>
              <Outlet />
            </DashboardFilterProvider>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
